import { getMessages } from 'src/services/MessagesService/agent';

export type StreamQuality = { good: number; bad: number; rated: number; percentage: string | null };

function readCount(response: unknown, feedback: 'good' | 'bad'): number {
    const page = response as { count?: unknown; results?: Array<{ feedback?: unknown; source?: unknown }> };
    if (
        !page ||
        !Number.isSafeInteger(page.count) ||
        Number(page.count) < 0 ||
        !Array.isArray(page.results) ||
        page.results.length !== (page.count === 0 ? 0 : 1) ||
        page.results.some((item) => !item || item.feedback !== feedback || item.source !== 'stream')
    ) {
        throw new Error('Не удалось проверить оценки потока');
    }
    return Number(page.count);
}

export function summarizeStreamQuality(good: number, bad: number): StreamQuality {
    const rated = good + bad;
    if (![good, bad, rated].every((n) => Number.isSafeInteger(n) && n >= 0))
        throw new Error('Некорректное число оценок');
    let percentage: string | null = null;
    if (rated > 0) {
        const rounded = Math.round((good / rated) * 1000) / 10;
        percentage =
            good > 0 && rounded === 0
                ? '<0,1%'
                : bad > 0 && rounded === 100
                ? '>99,9%'
                : `${new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 1 }).format(rounded)}%`;
    }
    return { good, bad, rated, percentage };
}

export async function getStreamQuality(streamId: number): Promise<StreamQuality> {
    if (!Number.isSafeInteger(streamId) || streamId <= 0) throw new Error('Некорректный поток');
    // Pagination counts are current account ratings of distinct delivered messages.
    // Profile feedback_counters count historical actions; they are not this denominator.
    const [good, bad] = await Promise.all(
        (['good', 'bad'] as const).map(async (feedback) => {
            const { data } = await getMessages({
                source: 'stream',
                streams: String(streamId),
                feedback,
                limit: 1,
                offset: 0,
            });
            return readCount(data, feedback);
        })
    );
    return summarizeStreamQuality(good, bad);
}
